// ActivityLog.js
import { useState, useEffect } from "react";
import { getActivityLog } from "../../service/Mainservice";
import Loader from "../../Loader/Loader";
import ListControls from "../ListControls/ListControls";
import Pagination from "../Pagination/pagination";
import "./ActivityLog.css";

// MUI Icons
import PersonIcon from "@mui/icons-material/Person";
import HistoryIcon from "@mui/icons-material/History";

const ActivityLog = () => {
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pagination, setPagination] = useState({
    page: 1,
    totalCount: 0,
    pageSize: 20,
  });

  const fetchLogs = async (page = 1) => {
    setLoading(true);
    try {
      const res = await getActivityLog({ limit: 20, page, sortBy, sortOrder });
      setLogs(res.data.logs || []);
      setPagination({
        page: res.data.page || 1,
        totalCount: res.data.totalCount || 0,
        pageSize: res.data.pageSize || 20,
      });
    } catch (err) {
      console.error(err);
      alert("Failed to load activity log");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(1);
  }, [sortBy, sortOrder]);

  // Helper to get action color
  const getActionColor = (action) => {
    if (action.includes("login")) return "action-login";
    if (
      action.includes("delete") ||
      action.includes("ban") ||
      action.includes("suspend")
    )
      return "action-danger";
    if (action.includes("create") || action.includes("add"))
      return "action-success";
    if (action.includes("update") || action.includes("edit"))
      return "action-warning";
    return "action-info";
  };

  return (
    <div className="activity-log-page">
      {loading ? (
        <Loader />
      ) : (
        <>
          <ListControls sortOptions={[{value:"createdAt",label:"Date"},{value:"adminEmail",label:"Admin email"},{value:"action",label:"Action"},{value:"ipAddress",label:"IP address"}]} sortBy={sortBy} sortOrder={sortOrder} onSortByChange={setSortBy} onSortOrderChange={setSortOrder} />
          <div className="table-wrapper">
            <table className="data_table">
              <thead>
                <tr>
                  <th>Admin</th>
                  <th>Action</th>
                  <th>Details</th>
                  <th>IP Address</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {logs.length === 0 ? (
                  <tr>
                    <td colSpan="5">No activity logs found.</td>
                  </tr>
                ) : (
                  logs.map((log) => (
                    <tr key={log.id}>
                      <td>
                        <div className="admin-info">
                          <strong>{log.admin?.fullName || "Unknown"}</strong>
                          <span>{log.admin?.email || ""}</span>
                        </div>
                      </td>
                      <td>
                        <span
                          className={`action-badge ${getActionColor(log.action)}`}
                        >
                          {log.action.replace(/_/g, " ").toUpperCase()}
                        </span>
                      </td>
                      <td>{log.details}</td>
                      <td>{log.ipAddress}</td>
                      <td>{new Date(log.createdAt).toLocaleString()}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <Pagination pagedata={pagination} onPageChange={fetchLogs} />
        </>
      )}
    </div>
  );
};

export default ActivityLog;
